import { render, staticRenderFns } from "./GraficoDeTorta.vue?vue&type=template&id=3b72ea62"
import script from "./GraficoDeTorta.vue?vue&type=script&lang=js"
export * from "./GraficoDeTorta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports